"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translate2d_1 = require("./translate2d");
var translateXy = {
    fromBrowser: function (x, y, _element, _viewBox, _chartXys) {
        var elementWidth = _element.offsetWidth;
        var elementHeight = _element.offsetHeight;
        var svgWidth = _viewBox.width;
        var svgHeight = _viewBox.height;
        var newXy = translate2d_1.translate2d([x, y], [[[0, 0], [elementWidth, 0]], [[0, 0], [0, elementHeight]]], [[[0, 0], [svgWidth, 0]], [[0, 0], [0, svgHeight]]]);
        var xys = _chartXys.map(function (xywh) {
            return translate2d_1.translate2d([newXy[0], newXy[1]], [[[xywh.x, xywh.y], [xywh.x + xywh.w, xywh.y]], [[xywh.x, xywh.y], [xywh.x, xywh.y + xywh.h]]], [[[0, 0], [xywh.w, 0]], [[0, 0], [0, xywh.h]]]);
        });
        return xys;
    },
    toBrowser: function (x, y, i, _element, _viewBox, _chartXys) {
        var elementWidth = _element.offsetWidth;
        var elementHeight = _element.offsetHeight;
        var svgWidth = _viewBox.width;
        var svgHeight = _viewBox.height;
        var xywh = _chartXys[i];
        var newXy = translate2d_1.translate2d([x, y], [[[0, 0], [xywh.w, 0]], [[0, 0], [0, xywh.h]]], [[[xywh.x, xywh.y], [xywh.x + xywh.w, xywh.y]], [[xywh.x, xywh.y], [xywh.x, xywh.y + xywh.h]]]);
        var xy = translate2d_1.translate2d([newXy[0], newXy[1]], [[[0, 0], [svgWidth, 0]], [[0, 0], [0, svgHeight]]], [[[0, 0], [elementWidth, 0]], [[0, 0], [0, elementHeight]]]);
        return xy;
    }
};
exports.default = translateXy;
